import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=33aca245&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aca245",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33aca245')) {
      api.createRecord('33aca245', component.options)
    } else {
      api.reload('33aca245', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=33aca245&scoped=true&", function () {
      api.rerender('33aca245', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2h3AAIEzH6t42/JS/comp/Voucher-Unit.vue"
export default component.exports